export function stickyHeader() {

    if(jQuery('.header-sticky').is(":visible")) {
        jQuery('body').addClass('sticky-header')
        let lastScrollTop = 0;
        jQuery(window).on('scroll', function() {
            let st = jQuery(this).scrollTop();
            if(st < lastScrollTop) {
                jQuery('body').addClass('sticky-header--sticky');
                jQuery('body').removeClass('sticky-header--not-sticky');
            }
            else {
                jQuery('body').removeClass('sticky-header--sticky');
                jQuery('body').addClass('sticky-header--not-sticky');
            }
            lastScrollTop = st;
        });
    }
}
